import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-layout__workspace" }
const _hoisted_2 = { class: "app-layout__content" }
const _hoisted_3 = {
  key: 0,
  class: "app-layout__breadcrumbs container-fluid"
}

import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import AppSidebar from '@/components/AppSidebar.vue'
import AppTopbar from '@/components/AppTopbar.vue'
import MobileNavigation from '@/components/MobileNavigation.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { navigationGroups, type NavigationGroup, type NavigationItem } from '@/config/navigation'
import { resolveBreadcrumbs } from '@/router/breadcrumbs'
import type { AuthUser } from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const sidebarCollapsed = ref(localStorage.getItem('docbrain_sidebar_collapsed') === 'true')
const currentUser = computed(() => store.getters.currentUser as AuthUser | null)
const showBreadcrumbs = computed(() => resolveBreadcrumbs(route).length > 0)

const hasPermission = (entry: NavigationGroup | NavigationItem) => {
  if (entry.roles?.length && !entry.roles.includes(currentUser.value?.role || '')) return false
  if (entry.module && !store.getters.hasModule(entry.module)) return false
  if (entry.permission === 'contabilidad' && !store.getters.hasContabilidadModule) return false
  if (entry.permission === 'amortizaciones' && !store.getters.canAccessAmortizaciones) return false
  return true
}

const visibleGroups = computed<NavigationGroup[]>(() =>
  navigationGroups
    .filter(hasPermission)
    .map((group) => ({ ...group, items: group.items.filter(hasPermission) }))
    .filter((group) => group.items.length > 0 || group.showWhenEmpty)
)

const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
  localStorage.setItem('docbrain_sidebar_collapsed', String(sidebarCollapsed.value))
}
const logout = () => {
  store.commit('clearAuth')
  router.push('/login')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-layout", { 'app-layout--collapsed': sidebarCollapsed.value }])
  }, [
    _createVNode(AppSidebar, {
      collapsed: sidebarCollapsed.value,
      groups: visibleGroups.value,
      onToggle: toggleSidebar,
      onLogout: logout
    }, null, 8, ["collapsed", "groups"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppTopbar, {
        collapsed: sidebarCollapsed.value,
        user: currentUser.value,
        onToggle: toggleSidebar,
        onLogout: logout
      }, null, 8, ["collapsed", "user"]),
      _createVNode(MobileNavigation, {
        groups: visibleGroups.value,
        user: currentUser.value,
        onLogout: logout
      }, null, 8, ["groups", "user"]),
      _createElementVNode("main", _hoisted_2, [
        (showBreadcrumbs.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(AppBreadcrumbs)
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})